import { useRouter } from 'next/router'
import { AffiliateWP } from '../helpers/Affiliate'
import { useEffect } from 'react'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import ShallowHeader from '../components/ShallowHeader'
import OurServices from '../components/HomePage/OurServices'
import WhyDirectMail from '../components/LandingPages/WhyDirect'
import OlmComparisonChart from '../components/SwitchToUs/OlmComparisonChart'
import Footer from '../components/Footer'
import { AFFWPAPI } from '../apis/server/ServerAxios'
import HeroSectionVersion2 from '../components/LandingPages/HeroSectionVersion2'

export default function AffiliatePage({ affiliate }) {
    const router = useRouter()

    useEffect(() => {
        let _router = { ...router }
        _router.query.ref = 90
        AffiliateWP.init(_router)
    }, [router.query])

    /** Hidden URL Visit */
    useEffect(() => {
        const img = new Image()
        img.src = 'https://openletterconnect.com/?fpr=morgan43'
    }, [])

    return (
        <LandingPageWrapper paddingFromTop={false} sectionSpacing={false}>
            <ShallowHeader metaTitle={'Results Driven'} />
            <div className="bg-[url('/assets/landing/blue-yellow-bg.png')] bg-cover bg-center md:pt-20 pt-10 pb-10 space-y-10 md:space-y-20">
                <HeroSectionVersion2 affiliate={affiliate} />
            </div>
            <OurServices
                showCoaches={false}
                heading={
                    <span className="text-black">
                        Why Open Letter Marketing?
                    </span>
                }
            />
            <WhyDirectMail />
            <OlmComparisonChart />
            <Footer />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    // Fetch the affiliate data based on the slug
    const { data: affiliate } = await AFFWPAPI.get('affiliates-data/90')

    // If no affiliate found, return 404
    if (!affiliate) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            affiliate, // Pass the affiliate data to the page component
            isComponent: true,
        },
        revalidate: 10, // In seconds
    }
}
